import { ColumnStartOrder, ColumnBib, ColumnWarnings, ColumnName, ColumnNoc, ColumnEventUnitEntries, ColumnExpander } from "components/common/TableColumns"
import { CompetitionFromStore } from 'helpers/utils'

export function TableColumns() {
    let competition = CompetitionFromStore()
    return (
        [
            ColumnStartOrder({ label: 'HeaderOrder' }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            ColumnEventUnitEntries({ code: 'PB', label: 'HeaderPBDesc' }),
            ColumnEventUnitEntries({ code: 'SB', label: 'HeaderSBDesc' }),
            ColumnEventUnitEntries({ code: 'RANK_WLD', label: competition === 'EG2023' ? 'HeaderEuropeanRank' : 'HeaderWorldRank' }),
            ColumnExpander({})
        ]
    )
}

export default TableColumns
